<template>
    <div class="create-line-broadcast-page">
      <vue-headful title="ALICE | Create Broadcast"></vue-headful>
      <ValidationObserver v-slot="{ handleSubmit, invalid }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="create-line-broadcast-side">
            <div>
              <div class="create-line-broadcast-container">
                <div class="broadcast-card-header">
                  <i class="ph-bold ph-megaphone"></i>
                  <p class="card-title">Broadcast information</p>
                </div>
                <div class="broadcast-card-body">
                  <div class="form-group">
                    <label class="create-broadcast-label" for="broadcast-name">Broadcast Name</label>
                      <ValidationProvider
                        :rules="{
                          required: {
                            value: true,
                            message: 'Plese enter a broadcast name.',
                          },
                          max: {
                            value: 256,
                          }
                        }"
                        v-slot="{ errors }"
                      >
                        <input
                          type="text"
                          id="broadcast-name"
                          class="broadcast-name-input"
                          placeholder="Enter broadcast name"
                          v-model="broadcastName"
                        />
                        <div class="error-message">
                          <p>{{ errors[0] }}</p>
                        </div>
                      </ValidationProvider>
                  </div>

                  <div class="form-group">
                    <label class="create-broadcast-label" for="broadcast-time">Broadcast Time</label>
                    <div class="broadcast-form-radio">
                      <label>
                        <input
                          type="radio"
                          name="time-option"
                          value="NOW"
                          v-model="broadcastTime"
                        />
                          Send now
                      </label>
                      <div class="schedule-braodcast">
                        <label>
                          <input
                          type="radio"
                          name="time-option"
                          value="SCHEDULE"
                          v-model="broadcastTime"
                        />
                          Schedule
                        </label>
                      <div class="broadcast-date-picker">
                        <ValidationProvider
                          :rules="{
                            required: {
                              value: broadcastTime === 'SCHEDULE',
                              message: 'Please select a date and time.',
                            },
                            custom: {
                              callback: isDateTimeSelectedValid,
                              message: 'Please enter a time 1 hour after the current time.',
                            }
                          }"
                          v-slot="{ errors }"
                        >
                          <date-range-picker
                            v-model="dateRange"
                            :show-dropdowns="true"
                            :singleDatePicker="true"
                            :ranges="false"
                            :timePicker="true"
                            :timePicker24Hour="true"
                            :min-date="minDateTime"
                            :time-picker-increment="1"
                            :disabled="broadcastTime !== 'SCHEDULE'"
                            opens="right"
                            class="date-picker"
                            :class="{
                              'disable-date-picker': broadcastTime !== 'SCHEDULE'
                            }"
                          >
                            <div class="date-selected" slot="input">
                              <i class="bx bx-calendar"></i>
                              <p v-if="dateRange.startDate === null">Select date and time</p>
                              <p v-else>{{ formatDatePicker(dateRange.startDate) }}</p>
                            </div>
                          </date-range-picker>
                          <div class="error-message">
                            <p v-if="Array.isArray(errors) && errors.length > 0">{{ errors[0] }}</p>
                            <p v-else class="help-text">
                              Set the schedule at least 1 hour from the current time.
                            </p>
                          </div>
                        </ValidationProvider>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="create-line-broadcast-container">
                <div class="broadcast-card-header">
                  <i class="bx bx-group"></i>
                  <p class="card-title">Recipients</p>
                </div>
              <div class="broadcast-card-body">
                <div class="form-group">
                  <label class="create-broadcast-label" for="target-audiences">Target audiences</label>
                  <div class="broadcast-form-radio">
                    <label>
                      <input
                        type="radio"
                        name="target-option"
                        value="ALL"
                        v-model="target"
                        @change="onBroadcastTargetChange('ALL')"
                      />
                      All friends
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="target-option"
                        value="CUSTOM"
                        v-model="target"
                        @change="onBroadcastTargetChange('CUSTOM')"
                      />
                      Custom group
                    </label>
                  </div>
                  <div class="create-custom-group" v-if="target === 'CUSTOM'">
                    <label for="group-name">Group name</label>
                    <ValidationProvider
                      :rules="{
                        required: {
                          value: target === 'CUSTOM',
                          message: 'Please enter a group name.',
                        },
                        max: {
                          value: 30,
                        }
                      }"
                      v-slot="{ errors }"
                    >
                      <input
                        type="text"
                        id="group-name"
                        class="group-name-input"
                        placeholder="Enter group name"
                        v-model="customTargetGroupName"
                      />
                      <div class="error-message">
                        <p>{{ errors[0] }}</p>
                      </div>
                    </ValidationProvider>
                    <label for="recipient-list">Recipient list</label>
                    <ValidationProvider
                      :rules="{
                        required: {
                          value: target === 'CUSTOM',
                          message: 'Please enter a user Id.',
                        },
                        custom: {
                          callback: isAllCustomRecipientIdsValid,
                          message: 'One or more user IDs are invalid format. Please check and try again.',
                        }
                      }"
                      v-slot="{ errors }"
                    >
                      <textarea
                        v-if="target === 'CUSTOM'"
                        id="recipient-list"
                        class="recipient-list-input"
                        placeholder="Enter recipient list"
                        v-model="recipientsText"
                        @blur="onCustomRecipientListBlur"
                      />
                      <div class="error-message error-recipient-list">
                        <p v-if="Array.isArray(errors) && errors.length > 0">{{ errors[0] }}</p>
                        <p v-else class="help-text-custom-group">
                          You can enter multiple user id using a new line
                        </p>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>
                <div>
                  <p class="create-broadcast-label">Target estimate</p>
                  <div class="target-estimate">
                    <div class="target-estimate-icon">
                      <i class="bx bx-user-check"></i>
                    </div>
                    <div v-if="isGettingEstimateTargetReach" class="target-estimate-text">
                      <div class="loading-section">
                        <div class="spinner-border" role="status"></div>
                        <p class="text-description">Loading...</p>
                      </div>
                    </div>
                    <div v-else class="target-estimate-text">
                      <div v-if="estimateRecipients < 0">
                        <p class="text-estimate-number">N/A</p>
                        <p class="text-description">Cannot estimate recipients</p>
                      </div>
                      <div v-else>
                        <p class="text-estimate-number">{{ estimateRecipients | number }} <span class="text-unit">recipients</span></p>
                        <p class="text-description">Approximately {{ estimateRecipients | number }} recipients will receive this will receive this broadcast.</p>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </div>
              <div class="create-line-broadcast-container">
                <div class="broadcast-card-header broadcast-messages">
                  <i class="bx bx-chat"></i>
                  <p class="card-title">Broadcast messages</p>
                </div>
                <ValidationProvider
                  :rules="{
                    custom: {
                      callback: validateAtLeastOneBroadcastMessage,
                      message: 'Please add a broadcast message',
                    },
                  }"
                  v-slot="{ errors, invalid }"
                  ref="broadcastMessagesProviderRef"
                >
                  <div class="error-message" v-if="invalid">
                    <p>{{ errors[0] }}</p>
                  </div>
                </ValidationProvider>
                <div class="broadcast-card-body">
                  <div v-for="(message, index) in selectedMessageList" :key="message.id">
                    <TextMessage
                      v-if="message.type === 'TEXT'"
                      :templateOrder="index"
                      :copiedTextMessage="message.textMessage"
                      @update-text-message="message.textMessage = $event"
                      @remove-message-template="removeMessageTemplate(message.id)"
                      />
                    <ImageMessage
                      v-else-if="message.type === 'IMAGE'"
                      :templateOrder="index"
                      :copiedImageMessage="message.imageMessage"
                      @remove-message-template="removeMessageTemplate(message.id)"
                      @update-image-message="message.imageMessage = $event"
                      @remove-image-message="removeImageMessage(index)"
                    />
                    <VideoMessage
                      v-else-if="message.type === 'VIDEO'"
                      :templateOrder="index"
                      :copiedVideoMessage="message.videoMessage"
                      @remove-message-template="removeMessageTemplate(message.id)"
                      @update-video-message="message.videoMessage = $event"
                      @remove-video-message="removeVideoMessage(index)"
                    />
                    <RichImageMessage
                      v-else-if="message.type === 'RICH_IMAGE'"
                      :templateOrder="index"
                      :copiedRichImageMessage="message.richImageMessage"
                      @remove-message-template="removeMessageTemplate(message.id)"
                      @update-rich-image-message="message.richImageMessage = $event"
                    />
                    <RichVideoMessage
                      v-else-if="message.type === 'RICH_VIDEO'"
                      :templateOrder="index"
                      :copiedRichVideoMessage="message.richVideoMessage"
                      @remove-message-template="removeMessageTemplate(message.id)"
                      @update-rich-video-message="message.richVideoMessage = $event"
                    />
                  </div>
                </div>
                <div v-if="selectedMessageList.length < 3" class="broadcast-card-body">
                  <div class="add-message-container">
                    <div class="header-message">
                      <p>Add Message</p>
                    </div>
                    <div class="message-type-container">
                      <div class="message-type-badge" @click="onSelectMessageType('TEXT')">
                        <i class="ph ph-text-t"></i>
                        <p>Text</p>
                      </div>
                      <div class="message-type-badge" @click="onSelectMessageType('IMAGE')">
                        <i class="ph ph-image-square"></i>
                        <p>Image</p>
                      </div>
                      <div class="message-type-badge" @click="onSelectMessageType('VIDEO')">
                        <i class="ph ph-video-camera"></i>
                        <p>Video</p>
                      </div>
                      <div class="message-type-badge" @click="onSelectMessageType('RICH_IMAGE')">
                        <i class="ph ph-file-image"></i>
                        <p>Rich Image</p>
                      </div>
                      <div class="message-type-badge" @click="onSelectMessageType('RICH_VIDEO')">
                        <i class="ph ph-file-video"></i>
                        <p>Rich Video</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="create-line-broadcast-container footer">
              <div class="broadcast-card-body">
                <div class="footer-container">
                  <button class="create-btn-secondary" @click="onCancelCreateLineBroadcast">Cancel</button>
                  <div class="footer-right">
                    <button
                        type="button"
                        class="create-btn-secondary"
                        :disabled="selectedMessageList.length <= 0"
                        @click="onPreviewLineBroadcast"
                        >
                        Preview
                      </button>
                    <button type="submit" v-if="broadcastTime === 'NOW'" class="create-btn-primary" :disabled="invalid">Send</button>
                    <button type="submit" v-else class="create-btn-primary" :disabled="invalid">Schedule</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <div class="preview-broadcast-side">
        <PreviewBroadcast :previewMessageList="previewMessageList"/>
      </div>
       <!-- Confirmation Modal -->
      <div class="confirmation-create-broadcast-modal" v-if="isCreateBroadcastConfirmationModalOpen">
        <div class="card-content">
          <div class="main-icon">
            <i class="bx bx-info-circle"></i>
          </div>
          <div class="modal-title">
            <p>Send Broadcast?</p>
          </div>
            <p v-if="broadcastTime === 'NOW'" class="modal-description truncated-text">This broadcast will be sent immediately. <br/>
              Do you want to continue?</p>
            <p v-else class="modal-description truncated-text">This broadcast will be sent to <span>{{ displayTargetAudience }}</span> at {{ formatScheduledTime }}.<br/>
              Do you want to continue?</p>
          <div class="modal-confirm-footer">
            <button class="modal-btn cancel-btn" @click="onCancelCreateLineBroadcastJob">Cancel</button>
            <button class="modal-btn confirm-btn" @click="onSendLineBroadcastJob" :disabled="isDisabledSendButton">Send</button>
          </div>
        </div>
      </div>
      <!--Auto Archive Modal -->
      <div class="confirmation-action-modal" v-if="isModalAutoArchiveOpen">
        <div class="card-content">
          <div
            @click="onCancelAutoArchiveLineBroadcast"
            class="close-icon"
          >
            <i class="bx bx-x"></i>
          </div>
          <div class="main-icon warning-archive-icon">
            <img src="@/assets/images/info-circle-icon.png" alt="info-circle-icon" />
          </div>
          <div class="modal-title">
            <p>Your media storage space is full</p>
          </div>
            <p class="modal-description truncated-text">Some older broadcasts will be archived to create a new broadcast. Are you sure you want to archived the older broadcasts? This action cannot be undone.</p>
          <div class="modal-auto-archive-footer">
            <button class="modal-btn cancel-btn" @click="onCancelAutoArchiveLineBroadcast">Cancel</button>
            <button class="modal-btn confirm-btn" @click="onConfirmAutoArchiveLineBroadcast">Create a new broadcast</button>
          </div>
        </div>
      </div>
      <!--Media storage full Modal -->
      <div class="confirmation-action-modal" v-if="isModalMediaStorageFullOpen">
        <div class="card-content">
          <div
            @click="onCloseModalMediaStorageFull"
            class="close-icon"
          >
            <i class="bx bx-x"></i>
          </div>
          <div class="main-icon warning-archive-icon">
            <img src="@/assets/images/info-circle-icon.png" alt="info-circle-icon" />
          </div>
          <div class="modal-title">
            <p>Your media storage space is full</p>
          </div>
            <p class="modal-description truncated-text">You have to delete some scheduled broadcasts to increase<br/>the space and then you can create a new broadcast</p>
          <div class="modal-auto-archive-footer">
            <button class="modal-btn cancel-btn" @click="onCloseModalMediaStorageFull">OK</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { DateTime } from 'luxon';
import { mapActions } from 'vuex';
import { debounce } from 'underscore';
import uniqid from 'uniqid';
import {
  ValidationObserver, ValidationProvider, extend
} from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import aliceApi from '../../../alice-api';
import TextMessage from './AddMessageTemplate/TextMessage.vue';
import ImageMessage from './AddMessageTemplate/ImageMessage.vue';
import VideoMessage from './AddMessageTemplate/VideoMessage.vue';
import RichImageMessage from './AddMessageTemplate/RichImageMessage.vue';
import RichVideoMessage from './AddMessageTemplate/RichVideoMessage.vue';
import PreviewBroadcast from './Preview/PreviewBroadcast.vue';

extend('required', {
  ...required,
  message: (field, values) => values?.message || `${field} is required.`,
  params: ['message'],
});

extend('custom', {
  // default fallback message (only used if no param message is passed)
  message: (fieldName, values) => values?.message || `${fieldName} is invalid.`,
  validate(value, { callback }) {
    return callback(value);
  },
  params: ['callback', 'message'],
});

extend('multiCustom', {
  async validate(value, { callbacks, messages }) {
    let results = [];
    try {
      results = await Promise.allSettled(callbacks.map((cb) => cb(value)));
    } catch (e) {
      // force to invalid
      return 'Invalid input';
    }

    for (let i = 0; i < results.length; i += 1) {
      const result = results[i];
      if (result.status !== 'fulfilled' || result.value !== true) {
        return messages?.[i] || 'Invalid input';
      }
    }
    return true;
  },
  params: ['callbacks', 'messages'],
  message: (field) => `${field} is required.`,
});

extend('max', {
  validate(value, { value: max }) {
    return value.length <= max;
  },
  params: ['value'],
  message: 'Character limit reached',
});

export default {
  name: 'CreateLineBroadcast',
  props: {
    isMediaStorageChecked: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TextMessage,
    ImageMessage,
    VideoMessage,
    RichImageMessage,
    RichVideoMessage,
    PreviewBroadcast,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      broadcastName: '',
      broadcastTime: 'NOW',
      dateRange: {
        startDate: null,
        endDate: null,
      },
      target: 'ALL',
      estimateRecipients: 0,
      selectedMessageList: [],
      customTargetGroupName: '',
      recipientsText: '',
      minDateTime: null,
      isCreateBroadcastConfirmationModalOpen: false,
      isDisabledSendButton: false,
      isGettingEstimateTargetReach: false,
      validationErrors: {},
      previewMessageList: [],
      isModalAutoArchiveOpen: false,
      isModalMediaStorageFullOpen: false,
      autoArchiveBroadcastId: null,
      isModalTriggeredBySubmit: false,
    };
  },
  async mounted() {
    let isReadyForCreateBroadcastFlow = this.isMediaStorageChecked;
    if (!isReadyForCreateBroadcastFlow) {
      isReadyForCreateBroadcastFlow = await this.canCreateNewLineBroadcast();
    }
    if (!isReadyForCreateBroadcastFlow) return;
    this.init();
  },
  beforeDestroy() {
    this.$emit('on-media-storage-check', false);
  },
  computed: {
    /**
     * Generates a list of validated custom recipients by filtering and processing unvalidated custom recipients.
     *
     * This function validates each recipient string based on specific criteria:
     * - The string must be non-empty after trimming whitespace.
     * - The string must match a predefined regex pattern (e.g., Line user ID format).
     *
     * The validated recipients are stored in a `Set` to ensure uniqueness, and the final output is returned as an array.
     *
     * @function
     * @returns {string[]} An array of unique and validated custom recipient strings.
     */
    listOfValidatedCustomRecipients() {
      const [listOfUnvalidatedCustomRecipients] = [this.listOfUnvalidatedCustomRecipients];

      const lineUserIdRegex = /^U[0-9a-f]{32}$/;
      const setOfValidatedCustomRecipients = new Set();
      for (const unvalidatedCustomRecipient of listOfUnvalidatedCustomRecipients) {
        if (typeof unvalidatedCustomRecipient === 'string' && unvalidatedCustomRecipient.trim().length > 0) {
          const unvalidatedCustomRecipientTrimmed = unvalidatedCustomRecipient.trim();
          // ensure that every loop regex will start at the beginning of string
          lineUserIdRegex.lastIndex = 0;
          if (lineUserIdRegex.test(unvalidatedCustomRecipientTrimmed)) {
            setOfValidatedCustomRecipients.add(unvalidatedCustomRecipientTrimmed);
          }
        }
      }
      return Array.from(setOfValidatedCustomRecipients);
    },
    /**
     * Retrieves a list of unvalidated custom recipients based on the provided `recipientsText`.
     * The method is applicable only if the target is set to 'CUSTOM'.
     *
     * The function validates `recipientsText` to ensure it is a string with meaningful content.
     * It splits the input by line, trims any extra spaces, and removes duplicates to produce
     * a unique array of unvalidated custom recipients.
     *
     * @returns {Array<string>} An array of unique and trimmed unvalidated custom recipient strings.
     */
    listOfUnvalidatedCustomRecipients() {
      if (this.target !== 'CUSTOM') {
        return [];
      }

      if (typeof this.recipientsText !== 'string' || this.recipientsText.trim().length <= 0) {
        return [];
      }

      const listOfSplitCustomRecipients = this.recipientsText.split('\n');
      const setOfUnvalidatedCustomRecipients = new Set();
      for (const eachLine of listOfSplitCustomRecipients) {
        if (typeof eachLine === 'string' && eachLine.trim().length > 0) {
          setOfUnvalidatedCustomRecipients.add(eachLine.trim());
        }
      }
      return Array.from(setOfUnvalidatedCustomRecipients);
    },
    displayTargetAudience() {
      if (this.target === 'ALL') return 'All friends';
      if (this.target === 'CUSTOM') return typeof this.customTargetGroupName === 'string' && this.customTargetGroupName.trim().length > 0 ? this.customTargetGroupName : 'Custom group';
      return 'Target audience';
    },
    formatScheduledTime() {
      if (this.broadcastTime === 'SCHEDULE' && this.dateRange.startDate) {
        return DateTime.fromJSDate(this.dateRange.startDate).toFormat('dd/MM/yyyy HH:mm');
      }
      return '';
    },
  },
  methods: {
    ...mapActions({
      createLineBroadcastJob: 'lineBroadcast/createLineBroadcastJob',
      archiveLineBroadcastJob: 'lineBroadcast/archiveLineBroadcastJob',
      checkAutomaticArchive: 'lineBroadcast/checkAutomaticArchive',
    }),
    init () {
      const lineBroadcastCopiedData = this.loadCopiedBroadcastData();
      if (lineBroadcastCopiedData && Object.keys(lineBroadcastCopiedData).length > 0) {
        this.applyLineBroadcastCopiedData(lineBroadcastCopiedData);
      } else {
        this.onSelectMessageType('TEXT');
      }
      this.onBroadcastTargetChange(this.target);
      this.minDateTime = DateTime.now().setZone('Asia/Bangkok').plus({ hours: 1 }).toFormat('yyyy-LL-dd HH:mm');
      this.$refs.broadcastMessagesProviderRef.validate(this.selectedMessageList.length);
    },
    async onSubmit() {
      this.isModalTriggeredBySubmit = true;
      const canCreateNewLineBroadcast = await this.canCreateNewLineBroadcast();
      if (!canCreateNewLineBroadcast) return;
      this.onCreateLineBroadcast();
    },
    validateAtLeastOneBroadcastMessage(value) {
      // This function receives length of selectedMessageList
      return typeof value === 'number' && !Number.isNaN(value) && value > 0;
    },
    onSelectMessageType(msgType) {
      if (this.selectedMessageList.length >= 3) return;
      this.selectedMessageList.push({
        id: uniqid('broadcast_message-'),
        type: msgType,
      });
      this.$refs.broadcastMessagesProviderRef.validate(this.selectedMessageList.length);
    },
    loadCopiedBroadcastData() {
      const lineBroadcastCopiedData = sessionStorage.getItem('lineBroadcastCopiedData');
      if (!lineBroadcastCopiedData || lineBroadcastCopiedData.trim().length <= 0) return false;
      try {
        return JSON.parse(lineBroadcastCopiedData);
      } catch (error) {
        return null;
      }
    },
    applyLineBroadcastCopiedData(lineBroadcastCopiedData) {
      this.broadcastName = lineBroadcastCopiedData.broadcastName;
      this.target = lineBroadcastCopiedData.target;
      this.estimateRecipients = lineBroadcastCopiedData.estimateRecipients;
      this.selectedMessageList = lineBroadcastCopiedData.selectedMessageList;
      this.recipientsText = lineBroadcastCopiedData.recipientsText;
      this.customTargetGroupName = lineBroadcastCopiedData.customTargetGroupName;
    },
    removeMessageTemplate(templateId) {
      this.selectedMessageList = this.selectedMessageList.filter(({ id }) => id !== templateId);
      this.$refs.broadcastMessagesProviderRef.validate(this.selectedMessageList.length);
    },
    onSendLineBroadcastJob: debounce(async function () {
      this.isDisabledSendButton = true;
      const requestBody = {
        name: this.broadcastName,
        totalRecipients: this.estimateRecipients,
        target: this.target,
        listOfMessages: this.formatMessageList(),
        // listOfRecipients: this.createListOfRecipients(this.recipientsText),
        listOfRecipients: this.listOfValidatedCustomRecipients,
      };
      if (this.target === 'CUSTOM') {
        requestBody.customTargetGroupName = this.customTargetGroupName;
      }
      if (this.broadcastTime === 'SCHEDULE') {
        requestBody.broadcastAt = this.formatJSDate(this.dateRange.startDate);
      }
      const isCreatesSuccess = await this.sendLineBroadcastJob(requestBody);
      if (isCreatesSuccess) {
        this.$buefy.toast.open({
          type: 'is-success',
          message: 'Your broadcast will be sent according to your specified settings.',
          position: 'is-bottom',
        });
        this.$router.push('/line-broadcast');
      } else {
        this.$buefy.toast.open({
          type: 'is-danger',
          message: 'Broadcast sending failed. Please try again.',
          position: 'is-bottom',
        });
        this.isDisabledSendButton = false;
      }
      this.isCreateBroadcastConfirmationModalOpen = false;
    }, 500),
    async sendLineBroadcastJob(requestBody) {
      try {
        await this.createLineBroadcastJob(requestBody);
        return true;
      } catch (error) {
        console.error('Line broadcast creation failed:', error);
        return false;
      }
    },
    onCreateLineBroadcast() {
      this.isCreateBroadcastConfirmationModalOpen = true;
    },
    onCancelCreateLineBroadcastJob() {
      this.isCreateBroadcastConfirmationModalOpen = false;
    },
    formatMessageList() {
      const messageList = [];
      if (this.selectedMessageList.length === 0) return messageList;
      for (let i = 0; i < this.selectedMessageList.length; i += 1) {
        const message = this.selectedMessageList[i];
        if (message.type === 'TEXT') {
          messageList.push({
            type: message.type,
            text: message.textMessage,
          });
        } else if (message.type === 'IMAGE') {
          if (message.imageMessage !== undefined) {
            messageList.push({
              type: message.type,
              originalContentUrl: message.imageMessage.filePath,
              previewImageUrl: message.imageMessage.filePath,
            });
          }
        } else if (message.type === 'VIDEO') {
          if (message.videoMessage !== undefined) {
            messageList.push({
              type: message.type,
              originalContentUrl: message.videoMessage.originalContentUrl,
              previewImageUrl: message.videoMessage.previewImageUrl,
            });
          }
        } else if (message.type === 'RICH_IMAGE') {
          messageList.push(message.richImageMessage);
        } else if (message.type === 'RICH_VIDEO') {
          messageList.push(message.richVideoMessage);
        }
      }
      return messageList;
    },
    formatJSDate(date) {
      if (!date) return '';
      return DateTime.fromJSDate(date).toUTC().toISO();
    },
    formatDatePicker(date) {
      if (!date) return '';
      return DateTime.fromJSDate(date).toFormat('yyyy-LL-dd HH:mm:ss');
    },
    onCancelCreateLineBroadcast() {
      this.$router.push('/line-broadcast');
    },
    validateCreateBroadcastForm() {
      this.validationErrors = {};
      let isValidBroadcastForm = true;
      // const listOfRecipients = this.createListOfRecipients(this.recipientsText);
      const listOfRecipients = this.listOfUnvalidatedCustomRecipients;
      if (this.broadcastName.trim().length <= 0) {
        this.validationErrors.broadcastName = 'Please enter a broadcast name';
        isValidBroadcastForm = false;
      }
      if (this.broadcastTime === 'SCHEDULE' && !this.isDateTimeSelectedValid()) {
        this.validationErrors.broadcastTime = 'Please enter a time 1 hour after the current time';
        isValidBroadcastForm = false;
      }
      if (this.selectedMessageList.length <= 0) {
        this.validationErrors.broadcastMessages = 'Please add a broadcast message';
        isValidBroadcastForm = false;
      }
      if (this.target === 'CUSTOM' && this.customTargetGroupName.trim().length <= 0) {
        this.validationErrors.customTargetGroupName = 'Please enter a group name';
        isValidBroadcastForm = false;
      }
      if (this.target === 'CUSTOM' && listOfRecipients.length <= 0) {
        this.validationErrors.broadcastRecipient = 'Please enter a user Id';
        isValidBroadcastForm = false;
      }
      if (this.target === 'CUSTOM' && this.isAllCustomRecipientIdsValid(listOfRecipients)) {
        this.validationErrors.broadcastRecipientInvalid = 'One or more user IDs are invalid format. Please check and try again.';
        isValidBroadcastForm = false;
      }
      // Check Each Broadcast Message
      if (!this.validateBroadcastMessages()) {
        isValidBroadcastForm = false;
      }
      return isValidBroadcastForm;
    },
    validateBroadcastMessages() {
      let isValidBroadcastMessages = true;
      for (let i = 0; i < this.selectedMessageList.length; i += 1) {
        const message = this.selectedMessageList[i];
        if (message.type === 'TEXT') {
          message.errorMessage = '';
          const validationResult = this.isTextMessageValid(message);
          if (!validationResult.isValid) {
            isValidBroadcastMessages = false;
            message.errorMessage = validationResult.errorMessage;
          }
        } else if (message.type === 'IMAGE') {
          message.errorMessage = '';
          if (message.imageMessage === undefined) {
            isValidBroadcastMessages = false;
            message.errorMessage = 'Please upload an image';
          }
        } else if (message.type === 'VIDEO') {
          message.errorMessage = {};
          if (!message.videoMessage || Object.keys(message.videoMessage).length <= 0) {
            message.errorMessage = {
              originalContentUrl: 'Please upload a video',
              previewImageUrl: 'Please upload a thumbnail',
            };
          } else {
            if (!this.hasValidText(message.videoMessage.originalContentUrl)) {
              isValidBroadcastMessages = false;
              message.errorMessage.originalContentUrl = 'Please upload a video';
            }
            if (!this.hasValidText(message.videoMessage.previewImageUrl)) {
              isValidBroadcastMessages = false;
              message.errorMessage.previewImageUrl = 'Please upload a thumbnail';
            }
          }
        } else if (message.type === 'RICH_IMAGE') {
          message.errorMessage = {};
          if (!message.richImageMessage || Object.keys(message.richImageMessage).length <= 0) {
            // show error all required fields
            isValidBroadcastMessages = false;
            message.errorMessage = {
              itemName: 'Please enter an item name',
              image: 'Please upload an image',
              url: 'Please enter an url',
            };
          } else {
            // check feild by field
            if (!this.hasValidText(message.richImageMessage.altText)) {
              isValidBroadcastMessages = false;
              message.errorMessage.itemName = 'Please enter an item name';
            }
            if (!this.hasValidText(message.richImageMessage.baseUrl)) {
              isValidBroadcastMessages = false;
              message.errorMessage.image = 'Please upload an image';
            }
            const hasActions = Array.isArray(message.richImageMessage.actions) && message.richImageMessage.actions.length > 0;
            const hasValidUrl = hasActions && this.hasValidText(message.richImageMessage.actions[0].linkUri);
            if (hasActions && !hasValidUrl) {
              isValidBroadcastMessages = false;
              message.errorMessage.url = 'Please enter an url';
            }
          }
        } else if (message.type === 'RICH_VIDEO') {
          message.errorMessage = {};
          if (!message.richVideoMessage || Object.keys(message.richVideoMessage).length <= 0) {
            isValidBroadcastMessages = false;
            message.errorMessage = {
              itemName: 'Please enter an item name',
              video: 'Please upload a video',
              thumbnail: 'Please upload a thumbnail',
              linkUrl: 'Please enter an url',
              label: 'Please enter an action button label',
            };
          } else {
            if (!this.hasValidText(message.richVideoMessage.altText)) {
              isValidBroadcastMessages = false;
              message.errorMessage.itemName = 'Please enter an item name';
            }
            const hasVideo = message.richVideoMessage.video && Object.keys(message.richVideoMessage.video).length > 0;
            if (hasVideo && !this.hasValidText(message.richVideoMessage.video.originalContentUrl)) {
              isValidBroadcastMessages = false;
              message.errorMessage.video = 'Please upload a video';
            }
            if (hasVideo && !this.hasValidText(message.richVideoMessage.video.previewImageUrl)) {
              isValidBroadcastMessages = false;
              message.errorMessage.thumbnail = 'Please upload a thumbnail';
            }
            if (hasVideo) {
              const hasExternalLink = hasVideo && message.richVideoMessage.video.externalLink;
              if (hasExternalLink && !this.hasValidText(message.richVideoMessage.video.externalLink.linkUri)) {
                isValidBroadcastMessages = false;
                message.errorMessage.linkUrl = 'Please enter an url';
              }
              if (hasExternalLink && !this.hasValidText(message.richVideoMessage.video.externalLink.label)) {
                isValidBroadcastMessages = false;
                message.errorMessage.label = 'Please enter an action button label';
              }
            }
          }
        }
      }
      return isValidBroadcastMessages;
    },
    isDateTimeSelectedValid() {
      if (this.broadcastTime === 'SCHEDULE') {
        return this.dateRange.startDate && DateTime.fromJSDate(this.dateRange.startDate).diffNow().as('hours') >= 1;
      }
      return true;
    },
    // TODO: using hasValidText instead of this function
    isTextMessageValid(message) {
      const isValid = message.textMessage && message.textMessage.trim().length > 0;
      return {
        isValid,
        errorMessage: isValid ? '' : 'Please enter in text message'
      };
    },
    hasValidText(text) {
      return text && text.trim().length > 0;
    },
    removeImageMessage(index) {
      delete this.selectedMessageList[index].imageMessage;
    },
    removeVideoMessage(index) {
      delete this.selectedMessageList[index].videoMessage;
    },
    isAllCustomRecipientIdsValid() {
      const listOfRecipients = this.listOfUnvalidatedCustomRecipients;
      if (!Array.isArray(listOfRecipients) || listOfRecipients.length <= 0) return false;
      const regex = /^U[0-9a-f]{32}$/;
      const isAllElementValid = listOfRecipients.every((item) => typeof item === 'string' && item.trim().length > 0 && regex.test(item.trim()));
      return isAllElementValid;
    },
    // createListOfRecipients(recipientsText) {
    //   if (!recipientsText || this.target !== 'CUSTOM') return [];
    //   return recipientsText
    //     .split('\n')
    //     .map((line) => line.trim())
    //     .filter(Boolean);
    // },

    // this will use when target is ALL only
    async getEstimateTargetReach(target) {
      const yearMonthDayString = DateTime.now().setZone('Asia/Bangkok').toFormat('yyyyLLdd');
      try {
        const response = await aliceApi.getEstimateTargetReach(target, yearMonthDayString);
        return response && response.data && response.data.data && typeof response.data.data.estimatedTargetReach === 'number' && !Number.isNaN(response.data.data.estimatedTargetReach) && response.data.data.estimatedTargetReach >= 0 ? response.data.data.estimatedTargetReach : -1;
      } catch (error) {
        return -1;
      }
    },
    // this will use when target is CUSTOM only
    countEstimateTargetReach() {
      return this.listOfValidatedCustomRecipients.length;
    },
    onBroadcastTargetChange(target) {
      this.isGettingEstimateTargetReach = true;
      this.debouncedOnBroadcastTargetChange(target);
    },
    debouncedOnBroadcastTargetChange: debounce(async function(target) {
      if (target === 'ALL') {
        this.estimateRecipients = await this.getEstimateTargetReach(target);
      } else if (target === 'CUSTOM') {
        this.estimateRecipients = this.countEstimateTargetReach();
      } else {
        // for unknown and unsupported target
        this.estimateRecipients = -1;
      }
      this.isGettingEstimateTargetReach = false;
    }, 1500),
    onCustomRecipientListBlur() {
      // TODO Reconsider this
      this.onBroadcastTargetChange('CUSTOM');
    },
    onPreviewLineBroadcast() {
      if (!this.validateBroadcastMessages()) return;
      this.previewMessageList = this.formatMessageList();
    },
    // -----------------------Check Media Storage------------------------
    async canCreateNewLineBroadcast() {
      try {
        await this.checkAutomaticArchive();
        return true;
      } catch (error) {
        if (error.response && error.response.status === 429) {
          this.handleArchiveModalOpen(error.response.data.data);
        }
        return false;
      }
    },
    handleArchiveModalOpen(archiveData) {
      if (archiveData.canAutomaticallyArchive) {
        this.autoArchiveBroadcastId = archiveData.broadcastJobIdToBeAutomaticallyArchive;
        this.onOpenModalAutoArchive();
      } else {
        this.onOpenMediaStorageFullModal();
      }
    },
    onOpenMediaStorageFullModal() {
      this.isModalMediaStorageFullOpen = true;
    },
    onCloseModalMediaStorageFull() {
      this.isModalMediaStorageFullOpen = false;
      if (this.isModalTriggeredBySubmit) return;
      this.$router.push('/line-broadcast');
    },
    onOpenModalAutoArchive() {
      this.isModalAutoArchiveOpen = true;
    },
    onCancelAutoArchiveLineBroadcast() {
      this.isModalAutoArchiveOpen = false;
      if (this.isModalTriggeredBySubmit) return;
      this.$router.push('/line-broadcast');
    },
    async onConfirmAutoArchiveLineBroadcast() {
      const isAutoArchiveBroadcastSuccess = await this.callArchiveBroadcastJobAPI(this.autoArchiveBroadcastId);
      if (isAutoArchiveBroadcastSuccess) {
        this.$buefy.toast.open({
          type: 'is-success',
          message: 'Broadcast has been successfully archived.',
          position: 'is-bottom',
        });
        if (!this.isModalTriggeredBySubmit) {
          this.init();
        }
      } else {
        this.$buefy.toast.open({
          type: 'is-danger',
          message: 'Archived failed. Please try again.',
          position: 'is-bottom',
        });
        if (!this.isModalTriggeredBySubmit) {
          this.$router.push('/line-broadcast');
        }
      }
      this.isModalAutoArchiveOpen = false;
      this.autoArchiveBroadcastId = null;
    },
    async callArchiveBroadcastJobAPI(id) {
      try {
        await this.archiveLineBroadcastJob(id);
        return true;
      } catch (error) {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.create-line-broadcast-page {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 0;
  min-height: 100vh;
  .preview-broadcast-side {
    position: sticky;
    top: 16px;
    align-self: flex-start;
    max-height: 100vh;
    max-width: fit-content;
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 10;
  }
  p, label{
    margin-bottom: 0px;
  }
  .create-line-broadcast-container{
    background-color: #fff;
    box-shadow: 0px 4px 16px 0px #868BA61A;
    border-radius: 16px;
    margin: 0px 16px 24px 40px;
    padding: 18px 20px;
    .broadcast-card-header{
      display: flex;
      justify-content: start;
      gap: 8px;
      .card-title{
        font-size: 16px;
        line-height: 120%;
        letter-spacing: 0px;
        line-height: 24px;
        font-weight: 500;
        color: #111B49;
      }
      &.broadcast-messages{
        margin-bottom: 0px;
      }
      margin-bottom: 20px;
      i{
        font-size: 20px;
        color: #4848FF;
      }
      }
    .broadcast-card-body{
      .create-broadcast-label{
        font-weight: 500;
        font-size: 14px;
        line-height: 150%;
        letter-spacing: 0px;
        color: #0D173C;
        margin-bottom: 12px;
        label{
          font-weight: 500;
          font-size: 14px;
          line-height: 24px;
          letter-spacing: 0px;
          color: #4B5178;
        }
      }
      .broadcast-name-input{
        width: 100%;
        height: 40px;
        padding: 8px 16px;
        border-radius: 8px;
        border: 1px solid #DADCE4;
        font-size: 14px;
        line-height: 150%;
        letter-spacing: 0px;
        color: #0D173C;
      }
      input:focus-visible{
        outline: none;
      }
      .broadcast-form-radio{
        display: flex;
        flex-direction: column;
        gap: 4px;
        label{
          font-weight: 500;
          line-height: 24px;
          font-size: 14px;
          letter-spacing: 0px;
          color: #4B5178;
          input{
            margin-right: 8px;
            cursor: pointer;
          }
        }
        .schedule-braodcast{
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .broadcast-date-picker{
          width: 240px;
          height: 40px;
          padding-right: 16px;
          .date-picker{
            width: 100%;
            .date-selected{
              display: flex;
              align-items: center;
              gap: 8px;
              font-weight: 400;
              font-size: 14px;
              line-height: 150%;
              letter-spacing: 0px;
              i{
                font-size: 20px;
                color: #4848FF;
              }
            }
          }
          .date-picker.disable-date-picker{
            pointer-events: none;
            opacity: 0.5;
          }
          .vue-daterange-picker ::v-deep .reportrange-text {
            height: 40px;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          .help-text{
            margin-top: 4px;
            font-weight: 400;
            font-size: 12px;
            line-height: 150%;
            letter-spacing: 0px;
            color: #868BA6;
            width: max-content;
          }
        }
      }
      .target-estimate{
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 12px;
        border-radius: 16px;
        border: 1px solid #D1F5E1;
        padding: 12px;
        width: max-content;
        min-width: 220px;
        .target-estimate-icon{
          width: 50px;
          height: 50px;
          background-color: #EDFBF3;
          border-radius: 16px;
          display: flex;
          justify-content: center;
          align-items: center;
          i{
            font-size: 32px;
            color: #50CD89;
          }
        }
        .target-estimate-text{
          .text-estimate-number{
            font-weight: 500;
            font-size: 20px;
            line-height: 120%;
            letter-spacing: 0px;
            color: #495057;
            .text-unit{
              font-weight: 400;
              font-size: 14px;
              line-height: 150%;
              letter-spacing: 0px;
              color: #646A8C;
            }
          }
          .text-description{
            font-weight: 400;
            font-size: 11px;
            line-height: 150%;
            letter-spacing: 0px;
            color: #868BA6;
          }
        }
        .loading-section{
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          height: 100%;
          width: 100%;
          gap: 5px;
        }
        .spinner-border {
          width: 1.5rem;
          height: 1.5rem;
        }
      }
      .add-message-container{
        margin-top: 20px;
        border: 1px solid #DADCE4;
        border-radius: 8px;
        .header-message{
          background-color: #F5F6FA;
          font-weight: 500;
          font-size: 14px;
          line-height: 24px;
          letter-spacing: 0px;
          color: #0D173C;
          padding: 10px 16px;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          border-bottom: 1px solid #DADCE4;
        }
        .message-type-container{
          padding: 20px 16px;
          display: flex;
          gap: 8px;
          .message-type-badge{
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
            padding: 6px 12px;
            border-radius: 24px;
            width: max-content;
            border: 1px solid #DADCE4;
            cursor: pointer;
            p{
              font-weight: 500;
              font-size: 14px;
              line-height: 24px;
              letter-spacing: 0px;
              color: #111B49;
            }
            i{
              font-size: 20px;
              color: #4848FF;
            }
          }
        }
      }
      .footer-container{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .footer-right{
          display: flex;
          gap: 8px;
        }
        .create-btn-primary{
          background-color: #4848FF;
          border: none;
          color: #fff;
          padding: 8px 16px;
          border-radius: 24px;
          font-weight: 500;
          font-size: 14px;
          line-height: 24px;
          letter-spacing: 0px;
          cursor: pointer;
          &:disabled {
            background-color: #DADCE4;
            color: #868BA6;
            cursor: not-allowed;
          }
        }
        .create-btn-secondary{
          border: 1px solid #DADCE4;
          background-color: #fff;
          color: #4848FF;
          padding: 8px 16px;
          border-radius: 24px;
          font-weight: 500;
          font-size: 14px;
          line-height: 24px;
          letter-spacing: 0px;
          cursor: pointer;
          &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
          &:hover:not(:disabled) {
            border: 1px solid #4848FF;
          }
        }
        button:focus,
        button:focus-visible,
        button:active {
          outline: none;
        }
      }
      .create-custom-group {
        padding-top: 18px;
        padding-left: 30px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        .help-text-custom-group{
          margin-left: 4px;
          margin-top: 4px;
          font-weight: 400;
          font-size: 12px;
          line-height: 150%;
          color: #868BA6;
          width: max-content;
        }
        .group-name-input{
          width: 100%;
          height: 40px;
          padding: 8px 16px;
          border-radius: 8px;
          border: 1px solid #DADCE4;
          font-size: 14px;
          line-height: 150%;
          color: #0D173C;
        }
        .recipient-list-input{
          width: 100%;
          height: 90px;
          padding: 8px 16px;
          border-radius: 8px;
          border: 1px solid #DADCE4;
          font-size: 14px;
          line-height: 150%;
          color: #0D173C;
          resize: none;
        }
        .recipient-list-input:focus-visible{
          outline: none;
        }
      }
    }
    &.footer{
      position: sticky;
      bottom: 20px;
      z-index: 99;
      width: auto;
    }
  }
  .confirmation-create-broadcast-modal{
    position: absolute;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0;
    z-index: 1041;
    background-color: rgba(0, 0, 0, 0.5);
    .card-content{
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #fff;
      width: 500px;
      height: fit-content;
      border-radius: 16px;
      margin-top: 30px;
      text-align: center;
      position: relative;
      padding: 24px;
      .modal-title{
        color: #0D173C;
        font-size: 20px;
        font-weight:500;
        line-height: 24px;
        margin-top: 16px;
        width: 400px;
      }
      .modal-description{
        color: #646A8C;
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        width: 100%;
        margin-top: 16px;
      }
      .truncated-text {
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .modal-confirm-footer{
        display: flex;
        justify-content: center;
        margin-top: 24px;
      }
      .modal-btn{
        border-radius: 24px;
        padding: 8px 16px;
        border: unset;
        margin: 4px;
        &.cancel-btn{
          color: #4848FF;
          background-color: #fff;
          border: 1px solid #4848FF;
          &:hover{
            cursor: pointer;
          }
        }
        &.confirm-btn{
          color: #fff;
          background-color: #4848FF;
          &:hover{
            cursor: pointer;
          }
          &:disabled {
            background-color: #DADCE4;
            color: #868BA6;
            cursor: not-allowed;
          }
        }
        &:focus{
          outline: 0px;
        }
      }
      .main-icon{
        i{
          font-size: 72px;
          color: #59CBE8;
        }
      }
    }
  }
  .error-message{
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    letter-spacing: 0px;
    color: #EF6767;
    margin-top: 4px;
    height: 18px;
    width: max-content;
    &.error-recipient-list{
      position: relative;
      top: -6px;
    }
  }
  .confirmation-action-modal{
    position: absolute;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0;
    z-index: 1041;
    background-color: rgba(0, 0, 0, 0.5);
    .card-content{
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #fff;
      width: 500px;
      height: fit-content;
      border-radius: 16px;
      margin-top: 30px;
      text-align: center;
      position: relative;
      padding: 24px;
      .modal-title{
        color: #0D173C;
        font-size: 20px;
        font-weight:500;
        line-height: 24px;
        margin-top: 16px;
        width: 400px;
      }
      .warning-archive-icon{
        padding-bottom: 14px;
      }
      .modal-description{
        color: #646A8C;
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        width: 100%;
        margin-top: 16px;
      }
      .truncated-text {
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .modal-auto-archive-footer{
        padding-top: 24px;
        .modal-btn{
          border-radius: 24px;
          padding: 8px 16px;
          border: unset;
          margin: 5px;
          &.cancel-btn{
            color: #FEA955;
            background-color: #fff;
            border: 1px solid #DADCE4;
            &:hover{
              cursor: pointer;
            }
          }
          &.confirm-btn{
            color: #fff;
            background-color: #FEA955;
            &:hover{
              cursor: pointer;
            }
            &:disabled {
              background-color: #DADCE4;
              color: #868BA6;
              cursor: not-allowed;
            }
          }
          &:focus{
            outline: 0px;
          }
        }
      }
      .close-icon{
        position: absolute;
        top: 20px;
        right: 14px;
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        cursor: pointer;
        i{
          color: #0000007F;
          font-size: 24px;
        }
      }
    }
  }
}
</style>
